import discountTypes from './discountTypes';
import { formatAmount } from '../../../common/money';

const isFixedAmount = discount => discount.type === discountTypes.fixed;

export const formatDiscount = (discount, currency) => {
  if (isFixedAmount(discount)) {
    return formatAmount(discount.value, currency);
  }

  return `${discount.value}%`;
};

export const convertValueToCents = (discount) => {
  if (isFixedAmount(discount)) {
    discount.value *= 100;
  }

  return discount;
};

export const applyAppointmentDiscount = (amount, discountAmount) => {
  return amount - discountAmount;
};
